import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";

export const TERMS_TEXT = `FUN CARD DEALS TERMS OF SERVICE
Effective Date: 06/12/2026
Welcome to Fun Card Deals ("Fun Card Deals," "Company," "we," "our," or "us").
These Terms of Service ("Terms") govern your access to and use of the Fun Card Deals website, mobile applications, and related services (collectively, the "Services").
By creating an account, accessing, browsing, or using the Services, you agree to be bound by these Terms.
If you do not agree with these Terms, do not use the Services.

1. Eligibility
You must be at least eighteen (18) years old to create an account or purchase a subscription.
By using the Services, you represent and warrant that:
You are legally capable of entering into a binding agreement;
Information you provide is accurate and current;
You will comply with all applicable laws.

2. User Accounts
Users may create accounts by providing:
First and last name;
Email address;
Address information;
Password credentials.
You are responsible for:
Maintaining the confidentiality of your account;
Restricting access to your account;
All activities occurring under your account.
Fun Card Deals may suspend or terminate accounts suspected of unauthorized activity.

3. Subscription Services
Certain portions of the Services require a paid subscription.
Subscription fees, billing periods, and renewal terms will be displayed at checkout.
Fun Card Deals reserves the right to:
Modify pricing;
Change subscription offerings;
Add or remove features.
Failure to maintain an active subscription may limit access to coupon benefits.

4. Payments
Payments are processed through third-party payment processors.
Fun Card Deals does not store complete payment card information.
By submitting payment information, you authorize the applicable payment processor to charge your selected payment method.

5. Coupons and Offers
Coupons and promotions displayed on Fun Card Deals are created by participating vendors and businesses.
Fun Card Deals does not guarantee:
Accuracy of offers;
Availability of offers;
Merchant participation;
Continued validity of promotions.
Offers may:
Expire without notice;
Be modified by merchants;
Be limited in quantity;
Be refused if misuse or fraud is suspected.
Fun Card Deals is not responsible for losses resulting from expired, inaccurate, unavailable, or discontinued offers.

6. Vendor Responsibilities
Vendors are solely responsible for:
Business information;
Coupon descriptions;
Images and uploaded materials;
Compliance with applicable laws;
Honoring approved promotions.
Fun Card Deals reserves the right to:
Review submissions;
Approve or reject vendors;
Remove businesses or coupons;
Suspend vendor accounts.
Approval is granted solely at the Company's discretion.

7. Reviews and User Content
Users may submit:
Ratings;
Reviews;
Comments;
Other content.
You agree not to submit content that is:
False;
Defamatory;
Harassing;
Offensive;
Fraudulent;
Illegal.
Fun Card Deals may remove any content at its sole discretion.

8. Content License
By submitting text, images, logos, banners, reviews, or other materials, you grant Fun Card Deals a non-exclusive, royalty-free, worldwide license to:
Display;
Reproduce;
Publish;
Resize;
Store;
Promote;
such content in connection with operating and marketing the Services.
You represent that you own or have the necessary rights to upload such materials.

9. Prohibited Conduct
You agree not to:
Share accounts;
Circumvent subscription requirements;
Use automated tools to scrape the Services;
Submit fraudulent coupon redemptions;
Upload malicious software;
Interfere with system operations;
Impersonate another person;
Engage in unlawful conduct.

10. Fraud Prevention
Fun Card Deals reserves the right to investigate suspected abuse, fraud, unauthorized coupon activity, or violations of these Terms.
Accounts may be suspended or terminated without prior notice.

11. Intellectual Property
The Fun Card Deals name, branding, logos, website design, software, and content are owned by Fun Card Deals and protected by applicable intellectual property laws.
No ownership rights are transferred to users.

12. Third-Party Links
The Services may contain links to third-party websites.
Fun Card Deals does not control and is not responsible for third-party websites, products, or services.

13. Account Termination
Fun Card Deals may suspend, restrict, or terminate accounts for:
Violations of these Terms;
Fraudulent activity;
Abuse of coupons;
Illegal conduct;
Misrepresentation.
Termination may occur without prior notice.

14. Disclaimer of Warranties
THE SERVICES ARE PROVIDED "AS IS" AND "AS AVAILABLE."
FUN CARD DEALS DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING:
MERCHANTABILITY;
FITNESS FOR A PARTICULAR PURPOSE;
NON-INFRINGEMENT.
We do not guarantee uninterrupted or error-free operation.

15. Limitation of Liability
TO THE MAXIMUM EXTENT PERMITTED BY LAW, FUN CARD DEALS SHALL NOT BE LIABLE FOR:
LOST PROFITS;
LOST SAVINGS;
INDIRECT DAMAGES;
INCIDENTAL DAMAGES;
CONSEQUENTIAL DAMAGES;
BUSINESS INTERRUPTION.
YOUR USE OF THE SERVICES IS AT YOUR OWN RISK.

16. Indemnification
You agree to defend, indemnify, and hold harmless Fun Card Deals and its owners, officers, employees, and affiliates from claims arising out of:
Your use of the Services;
Your uploaded content;
Your violation of these Terms;
Your violation of applicable law.

17. Privacy
Your use of the Services is also governed by the Fun Card Deals Privacy Policy.

18. Changes to Terms
Fun Card Deals may modify these Terms at any time.
Continued use of the Services after modifications constitutes acceptance of the updated Terms.

19. Governing Law
These Terms shall be governed by the laws of the State of Florida, without regard to conflict of law principles.

20. Severability
If any provision of these Terms is found unenforceable, the remaining provisions shall remain in full force and effect.

21. Contact Information
Fun Card Deals
Website: www.funcarddeals.com
Email: info@funcardmarketing.com

By using the Services, you acknowledge that you have read and agree to these Terms of Service.


────────────────────────────────────────────────────────────────────

FUN CARD DEALS REFUND POLICY
Effective Date: 06/12/2026
Fun Card Deals offers subscription access to promotional discounts and coupons.

Subscription Charges
Subscription fees are charged according to the plan selected during checkout.

Cancellation
Subscribers may cancel at any time.
Cancellation prevents future billing but does not automatically generate a refund for previous charges.

Refund Requests
Refund requests are reviewed individually.
Refunds may be granted for:
duplicate charges;
billing errors;
technical failures preventing access.
Refunds generally will not be issued for:
unused memberships;
dissatisfaction with individual offers;
expired promotions;
merchant-specific issues.

Vendor Advertising Fees
Payments for:
featured coupons;
category placements;
promotional upgrades;
are generally non-refundable.

Chargebacks
Fraudulent chargebacks may result in account suspension or termination.

Contact
For billing issues, contact:
Email: info@funcardmarketing.com

────────────────────────────────────────────────────────────────────

FUN CARD DEALS COOKIE POLICY
Effective Date: 06/12/2026
Fun Card Deals uses cookies and similar technologies to improve the user experience.

What Are Cookies?
Cookies are small text files stored on your device when visiting websites.

Types of Cookies We Use
Essential Cookies
Used for:
account login;
session management;
security.
Functional Cookies
Used to:
remember preferences;
improve usability.
Analytics Cookies
Used to:
understand website traffic;
analyze performance;
improve features.
Marketing Cookies
May be used to deliver relevant promotions and advertisements.

Third-Party Cookies
Third-party services may place cookies through our website, including:
analytics providers;
payment processors;
advertising providers.
These providers maintain their own privacy policies.

Managing Cookies
Most browsers allow you to:
block cookies;
delete cookies;
receive notifications before cookies are stored.
Disabling cookies may limit certain features of the Services.

Updates
Fun Card Deals may modify this Cookie Policy periodically.
Continued use of the Services constitutes acceptance of any revisions.

Contact
Website: www.funcarddeals.com
Email: info@funcardmarketing.com

────────────────────────────────────────────────────────────────────

FUN CARD DEALS SMS MESSAGING POLICY
Effective Date: 06/12/2026
If Fun Card Deals offers text messaging services, this policy governs those communications.

Consent
By providing a mobile phone number and opting in, you consent to receive:
account notifications;
subscription notices;
promotional offers;
security alerts.

Frequency
Message frequency may vary.

Fees
Message and data rates may apply according to your wireless carrier.

Opt-Out
Users may stop receiving text messages at any time by:
replying STOP; or
contacting customer support.

Supported Carriers
Delivery is subject to carrier availability.
Fun Card Deals is not responsible for delayed or undelivered messages.

Privacy
Phone numbers collected for SMS communications are subject to the Fun Card Deals Privacy Policy.

Changes
Fun Card Deals reserves the right to modify this policy.

────────────────────────────────────────────────────────────────────

FUN CARD DEALS CALIFORNIA PRIVACY RIGHTS ADDENDUM
Effective Date: 06/12/2026
This Addendum applies to California residents and supplements the Fun Card Deals Privacy Policy.

Rights Available to California Residents
California residents may have the right to:
Know
Request information regarding:
categories of personal information collected;
sources of information;
purposes for collection;
categories of third parties receiving information.
Access
Request a copy of personal information collected.
Correct
Request correction of inaccurate information.
Delete
Request deletion of certain personal information, subject to legal exceptions.
Non-Discrimination
Fun Card Deals will not discriminate against users who exercise privacy rights.

Sale of Personal Information
Fun Card Deals does not sell personal information.

Exercising Your Rights
Requests may be submitted by contacting:
Email: info@funcardmarketing.com
Fun Card Deals may verify your identity before processing requests.

Authorized Agents
California residents may designate authorized agents to act on their behalf.

Changes
Fun Card Deals may update this Addendum periodically.

────────────────────────────────────────────────────────────────────

FUN CARD DEALS VENDOR AGREEMENT
Effective Date: 06/12/2026
This Vendor Agreement ("Agreement") governs participation by vendors, merchants, and businesses ("Vendor") on Fun Card Deals.
By registering as a Vendor, you agree to the following:

1. Vendor Eligibility
Vendor represents that:
The business is legally operating;
Vendor has authority to act on behalf of the business;
Information provided is accurate and current.

2. Approval Process
Submission of a vendor account does not guarantee approval.
Fun Card Deals may:
approve;
deny;
suspend;
remove;
any vendor account at its sole discretion.

3. Accuracy of Information
Vendor is solely responsible for:
business descriptions;
addresses;
phone numbers;
websites;
coupon details;
pricing information.
Vendor agrees to promptly update inaccurate information.

4. Coupon Obligations
Vendor agrees to honor all approved offers appearing on Fun Card Deals.
Vendor may not:
misrepresent discounts;
advertise unavailable products;
intentionally deceive customers.

5. Images and Intellectual Property
Vendor represents that it owns or has permission to use all uploaded:
logos;
photos;
banners;
trademarks;
promotional materials.
Vendor grants Fun Card Deals a non-exclusive, worldwide, royalty-free license to display and promote submitted content.

6. Featured Listings and Advertising
Fees paid for featured placement or advertising are non-refundable unless otherwise required by law.
Placement duration and visibility are not guaranteed.

7. Prohibited Content
Vendor may not upload content that:
infringes copyrights;
violates laws;
contains misleading claims;
contains offensive material.

8. Customer Complaints
Fun Card Deals may investigate complaints and remove offers that generate excessive disputes.

9. Suspension and Removal
Fun Card Deals may suspend or terminate Vendor access for:
fraud;
repeated complaints;
misleading promotions;
violations of this Agreement.

10. Limitation of Liability
Fun Card Deals is not responsible for:
lost revenue;
missed sales;
customer disputes;
business interruption.

11. Governing Law
This Agreement shall be governed by the laws of the State of Florida.

────────────────────────────────────────────────────────────────────

FUN CARD DEALS DMCA COPYRIGHT POLICY
Effective Date: 06/12/2026
Fun Card Deals respects the intellectual property rights of others and expects users and vendors to do the same.
If you believe content appearing on Fun Card Deals infringes your copyright, you may submit a Digital Millennium Copyright Act ("DMCA") notice.

Filing a DMCA Notice
Your written notice must include:
Identification of the copyrighted work claimed to have been infringed;
Identification of the material alleged to be infringing;
The location (URL) of the allegedly infringing material;
Your name, address, telephone number, and email address;
A statement that you have a good faith belief that the use is unauthorized;
A statement, under penalty of perjury, that the information is accurate and that you are authorized to act on behalf of the copyright owner;
Your physical or electronic signature.

Removal of Content
Fun Card Deals may remove allegedly infringing content while an investigation is conducted.

Repeat Infringers
Accounts associated with repeated copyright violations may be suspended or permanently terminated.

Counter Notifications
If content was removed in error, affected parties may submit a counter-notification in accordance with applicable law.

DMCA Contact
Email: info@funcardmarketing.com
Fun Card Deals reserves the right to modify this policy at any time.

────────────────────────────────────────────────────────────────────

FUN CARD DEALS AFFILIATE DISCLOSURE
Effective Date: 06/12/2026
Fun Card Deals may participate in affiliate marketing programs.
This means we may receive compensation when users purchase products or services through certain links appearing on our website.

Editorial Independence
Compensation does not influence our opinions or recommendations.
We strive to provide accurate and unbiased information.

Third-Party Relationships
Affiliate partners maintain their own:
terms of service;
privacy policies;
refund policies.
Fun Card Deals is not responsible for third-party products or services.

No Additional Cost
Purchases made through affiliate links generally do not increase the price paid by users.

FTC Compliance
This disclosure is intended to comply with the Federal Trade Commission's endorsement and advertising guidelines.

Changes
Fun Card Deals may update this disclosure periodically.

Contact
Website: www.funcarddeals.com
Email: info@funcardmarketing.com

────────────────────────────────────────────────────────────────────

FUN CARD DEALS ACCEPTABLE USE POLICY
Effective Date: 06/12/2026
Users and vendors agree not to misuse the Services.

Prohibited Activities
Users may not:
Fraud and Abuse
redeem coupons dishonestly;
create multiple accounts to bypass limits;
manipulate reviews;
impersonate others.
Technical Abuse
scrape the website;
reverse engineer software;
attack systems;
upload malware.
Illegal Conduct
violate applicable laws;
infringe intellectual property rights;
distribute harmful or offensive content.
False Information
Users and vendors may not submit:
fake businesses;
misleading advertisements;
fraudulent reviews;
deceptive claims.

Enforcement
Fun Card Deals may:
remove content;
suspend accounts;
permanently ban users;
report unlawful conduct to authorities.
Enforcement decisions are made at Fun Card Deals' sole discretion.`;

const TermsModal = ({ isOpen, onClose, onAgree, accountType = "Account" }) => {
    const [agreed, setAgreed] = useState(false);

    useEffect(() => {
        if (isOpen) setAgreed(false);
    }, [isOpen]);

    if (!isOpen) return null;

    const handleAgree = () => {
        if (!agreed) return;
        onAgree();
        onClose();
    };

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) onClose();
    };

    return ReactDOM.createPortal(
        <>
            <style>{`
                .terms-overlay {
                    position: fixed;
                    inset: 0;
                    background: rgba(0, 0, 0, 0.55);
                    z-index: 9999;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 20px;
                    backdrop-filter: blur(2px);
                }
                .terms-modal {
                    background: #fff;
                    border-radius: 18px;
                    box-shadow: 0 20px 60px rgba(0,0,0,0.2);
                    width: 100%;
                    max-width: 680px;
                    max-height: 90vh;
                    display: flex;
                    flex-direction: column;
                    overflow: hidden;
                }
                .terms-modal-header {
                    padding: 24px 28px 16px;
                    border-bottom: 1px solid #f0f0f0;
                    flex-shrink: 0;
                }
                .terms-scroll {
                    flex: 1;
                    overflow-y: auto;
                    padding: 20px 28px;
                    background: #f8f9fb;
                    font-size: 13px;
                    line-height: 1.75;
                    color: #374151;
                    white-space: pre-wrap;
                    font-family: 'Courier New', Courier, monospace;
                    border-top: 1px solid #e9ecf0;
                    border-bottom: 1px solid #e9ecf0;
                }
                .terms-scroll::-webkit-scrollbar { width: 6px; }
                .terms-scroll::-webkit-scrollbar-track { background: #f0f0f0; }
                .terms-scroll::-webkit-scrollbar-thumb { background: #c0c8d8; border-radius: 3px; }
                .terms-modal-footer {
                    padding: 20px 28px 24px;
                    flex-shrink: 0;
                    background: #fff;
                }
                .terms-checkbox-row {
                    display: flex;
                    align-items: flex-start;
                    gap: 12px;
                    padding: 14px 16px;
                    background: #f0f6ff;
                    border: 1.5px solid #c3d9ff;
                    border-radius: 10px;
                    margin-bottom: 16px;
                    cursor: pointer;
                }
                .terms-checkbox-row input[type="checkbox"] {
                    width: 18px;
                    height: 18px;
                    flex-shrink: 0;
                    margin-top: 2px;
                    cursor: pointer;
                    accent-color: #2575fc;
                }
                .terms-checkbox-label {
                    font-size: 13px;
                    color: #1e3a6e;
                    line-height: 1.5;
                    font-weight: 500;
                    cursor: pointer;
                    margin: 0;
                }
                .terms-agree-btn {
                    width: 100%;
                    padding: 13px 24px;
                    border: none;
                    border-radius: 11px;
                    font-size: 15px;
                    font-weight: 700;
                    cursor: pointer;
                    transition: opacity 0.15s, transform 0.1s;
                    background: #6B9FD4;
                    color: #fff;
                    letter-spacing: 0.2px;
                }
                .terms-agree-btn:hover:not(:disabled) { opacity: 0.9; transform: translateY(-1px); }
                .terms-agree-btn:disabled { opacity: 0.45; cursor: not-allowed; }
                .terms-cancel-btn {
                    width: 100%;
                    padding: 10px 24px;
                    border: 1.5px solid #e9ecf0;
                    border-radius: 11px;
                    font-size: 14px;
                    font-weight: 600;
                    cursor: pointer;
                    background: transparent;
                    color: #6b7280;
                    margin-top: 10px;
                    transition: border-color 0.15s, color 0.15s;
                }
                .terms-cancel-btn:hover { border-color: #c0c8d8; color: #374151; }
            `}</style>

            <div className="terms-overlay" onClick={handleOverlayClick}>
                <div className="terms-modal">
                    <div className="terms-modal-header">
                        <div className="d-flex align-items-center gap-10 mb-6">
                            <div
                                className="d-inline-flex align-items-center justify-content-center rounded-10 flex-shrink-0"
                                style={{ width: 38, height: 38, background: "#eef4ff" }}
                            >
                                <i className="ph ph-file-text" style={{ fontSize: 20, color: "#2575fc" }} />
                            </div>
                            <div>
                                <h5 className="fw-bold mb-0" style={{ fontSize: 18, color: "#0f172a" }}>
                                    Terms of Service &amp; Policies
                                </h5>
                                <p className="mb-0" style={{ fontSize: 12, color: "#94a3b8" }}>
                                    Please read and agree before creating your account
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="terms-scroll">
                        {TERMS_TEXT}
                    </div>

                    <div className="terms-modal-footer">
                        <label className="terms-checkbox-row" htmlFor="terms-agree-checkbox">
                            <input
                                type="checkbox"
                                id="terms-agree-checkbox"
                                checked={agreed}
                                onChange={(e) => setAgreed(e.target.checked)}
                            />
                            <span className="terms-checkbox-label">
                                By creating an account, I confirm that I have read and agree to the Fun Card Deals
                                Terms of Service and related policies, and I acknowledge that I am at least 18 years of age.
                            </span>
                        </label>

                        <button
                            className="terms-agree-btn"
                            onClick={handleAgree}
                            disabled={!agreed}
                        >
                            Agree and Create {accountType}
                        </button>

                        <button className="terms-cancel-btn" onClick={onClose}>
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </>,
        document.body
    );
};

export default TermsModal;
